import { Box } from "@mui/material";
import React from "react";

export const SurveysPage = () => {
  return <Box>SurveysPage</Box>;
};
